//Local Storage Key
export const CAMPAIGN_POINTS_SOURCE = 'campaign_points_source';
export const CAMPAIGN_EVENT6 = "campaignEvent6";

// Action Types
const SET_CAMPAIGN_SOURCE = 'SET_CAMPAIGN_SOURCE';

// States
export const DRAMA_FINISHED = 'DRAMA_FINISHED';
export const RATING = 'RATING';
export const FAVORITE = 'FAVORITE';
export const COMMENT = 'COMMENT';

const allStates = Object.freeze([
  DRAMA_FINISHED,
  RATING,
  FAVORITE,
  COMMENT,
]);

// Action Creators
export function setCampaignSource(source) {
  return {
    type: SET_CAMPAIGN_SOURCE,
    payload: source,
  };
}

// Reducer
export default function reducer(state = '', action) {
  return action.type === SET_CAMPAIGN_SOURCE && allStates.includes(action.payload) ? action.payload : state;
}
